// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const localeMappings: any = {
    "ar-AR": "ar",
    "br-PT": "pt",
    "ca-ES": "ca",
    "cs-CZ": "cs",
    "da-DK": "da",
    "de-DE": "de",
    "en-AU": "en",
    "en-NZ": "en",
    "en-UK": "en",
    "en": "en",
    "es-ES": "es",
    "fa-FA": "fa",
    "fi-FI": "fi",
    "fr-CA": "fr",
    "fr-FR": "fr",
    "gb-CY": "cy",
    "gr-GR": "el",
    "he-HE": "he",
    "is-IS": "is",
    "it-IT": "it",
    "jp": "ja",
    "ko-KO": "ko",
    "mi-NZ": "mi",
    "ms-MY": "ms",
    "nl-NL": "nl",
    "no-NO": "nb",
    "pl": "pl",
    "pt-PT": "pt",
    "ru-RU": "ru",
    "sv-SE": "sv",
    "th-TH": "th",
    "tu-TU": "tr",
    "za-CN": "zh-tw",
    "zh-CN": "zh"
};

const port: any = process.env.PORT || 9000;

const ResearchAssistant = ($rootScope: any, $authEvents: any, localizationService: LocalizationService, configService: ConfigService, authenticationService: AuthenticationService, researchAssistantService: ResearchAssistantService) => ({
    replace: false,
    templateUrl: '/assets/researchAssistant.html',
    controllerAs: 'ra',
    controller: ResearchAssistantController,
    authenticationService,

    link(scope: any, element: any, attr: any, controller?: ResearchAssistantController) {
        scope.standardLocale = localizationService.getStandardLocale();
        scope.language = (localeMappings[scope.standardLocale] || scope.standardLocale).toLowerCase();
        scope.baseURL = this.getBaseURLForClientEnv();
        scope.libhash = this.getLibhash();
        scope.researchAssistantService = researchAssistantService

        //this listener listens to the login success event and updates the API params for the provider
        $rootScope.$on($authEvents.LOGINSUCCESS, (_event: any, data: any) => {
            
            // Skip reload if this is a cross-tab sync - just update the API params
            if (data?.fromStorageSync) {
                const $log = (angular as any).element(document.body).injector().get('$log');
                $log.debug('Login event from storage sync');
                return;
            }

            let providerName = this.getProviderName()
            let loginInfo = {
                provider: providerName,
                csrf: this.getCSRF(providerName),
                user: this.getUser(providerName)
            }
            this.updateAPIParamsForProvider(loginInfo);

            // Refresh the page at login (only fresh logins on current tab) to ensure the latest data is loaded
            window.location.reload();
        });


        $rootScope.$on($authEvents.LOGOUTSUCCESS, () => {
            // Refresh the page at logout to ensure the chat history is removed
            window.location.reload();
        });

        //this listener listens to the csrfTokenRefreshed event and updates the API params for the provider
        $rootScope.$on('csrfTokenRefreshed', (event: any, loginInfo: any) => {
            this.updateAPIParamsForProvider(loginInfo)
        })

        // Wait until both `language` and `baseURL` are ready
        if (scope.language && scope.baseURL) {
            // Dynamically create and inject the component
            const placeholder = document.getElementById('research-assistant-placeholder');
            if (placeholder) {
                let providerName = this.getProviderName()
                placeholder.innerHTML = `
                    <cdi-research-assistant
                        id="research-assistant"
                        height="90vh"
                        client-key="${scope.libhash}"
                        product="summon"
                        show-beta="true"
                        language="${scope.language}"
                        api-url="/research-assistant"
                        shows-toasts="true"
                        show-advanced="true"
                        enable-history="${this.enableHistory()}"
                        how-to-cite-link="${configService.data.researchAssistant.citeLink}"
                        enable-history="${this.enableHistory()}"
                        api-params='${JSON.stringify({
                    provider: providerName, csrf: this.getCSRF(providerName), user: this.getUser(providerName)
                })}'
                        show-quotum="true">
                    </cdi-research-assistant>
                `;
                controller?.listenToClickInResearchAssistantDocument()
                setTimeout(() => {
                    const researchAssistantElement = document.getElementById('research-assistant');
                    if (researchAssistantElement) {
                        researchAssistantElement.addEventListener('stats', (e: any) => {
                            const {detail} = e as CustomEvent
                            const enhancedDetail = {
                                ...detail,
                                userId: this.getUser(this.getProviderName()),
                                clientKey: scope.libhash
                            }
                            researchAssistantService.sendRAStatActions(enhancedDetail)
                        })
                    }
                }, 0)
            } else {
                console.error("Placeholder element for the component was not found.");
            }
        } else {
            console.error("Required properties are not ready: language or baseURL is missing.");
        }
    },

    getBaseURLForClientEnv(): string {
        const currentEnv = configService.data.env.value;
        const currentClient = configService.data.head.client;
        switch (currentEnv) {
            case 'development':
                return `http://localhost:${port}`;
            case 'test':
                return `https://${currentClient}.test.summon.serialssolutions.com`;
            case 'ci':
                return `https://${currentClient}.ci.summon.serialssolutions.com`;
            case 'preview':
                return `https://${currentClient}.preview.summon.serialssolutions.com`;
            case 'production':
                return `https://${currentClient}.summon.serialssolutions.com`;
            default:
                console.warn(`Unknown environment: ${currentClient} . ${currentEnv}`);
                return `https://${currentClient}.preview.summon.serialssolutions.com`; // Default to preview
        }
    },

    getLibhash(): string {
        return configService.data.availability.libHash
    },

    getProviderName(): string {
        return authenticationService.getLoggedInProviderForFeature('research_assistant') || ''
    },

    getCSRF(providerName: string): string {
        return authenticationService.getAuthValue(providerName, 'csrf') || ''
    },

    getUser(providerName: string): string {
        return authenticationService.getAuthValue(providerName, 'user') || 'session:' + configService.data.researchAssistant.session_id
    },

    //this method is used to update CSRF when user logs in again without refreshing the application
    updateAPIParamsForProvider(provider: any) {
        const researchAssistantElement = document.getElementById('research-assistant');
        if (researchAssistantElement) {
            // Update the attribute
            researchAssistantElement.setAttribute('api-params', JSON.stringify(provider));
            console.log('API params updated for provider:', researchAssistantElement);
        } else {
            console.error('Element with id "research-assistant" not found.');
        }
    },

    enableHistory(): boolean {
        return !configService.data.researchAssistant.disableHistory
    }
});

class ResearchAssistantController {
    $scope: any
    researchAssistantService: any
    apiService: ApiService
    params: any
    documentService: any

    constructor($scope: any, researchAssistantService: ResearchAssistantService, apiService: ApiService, appStateService: AppStateService, documentService: DocumentService) {
        this.$scope = $scope
        this.researchAssistantService = researchAssistantService
        this.apiService = apiService
        this.params = angular.copy(appStateService.defaults, {})
        this.documentService = documentService
    }

    listenToClickInResearchAssistantDocument() {
        const researchAssistantEl = document.getElementById('research-assistant')

        if (researchAssistantEl) {
            researchAssistantEl.addEventListener('application', (e: any) => {
                if (e.detail.event === 'source' && e.detail.status === 'click' && e.detail.value) {
                    e.preventDefault()
                    this.toggleQuickLookForResearchAssistant(e.detail.value)
                }
            })
        }
    }

    toggleQuickLookForResearchAssistant(id: any) {
        if (id.startsWith('cdi_')) {
            id = id.substring(4)
        }

        this.params.solrPassThroughQuery = `(sys_participant_id:${id})`
        this.params.pn = 0
        this.params.ps = 1
        this.params.ho = 'f'
        this.apiService.searchResearchAssistantDocument(this.params).then((response: any) => {
            let doc = response.data.documents[0]
            if (doc) {
                doc = this.documentService.getResearchResultDocument(doc)
                this.$scope.toggleQuickLook(doc)
            }
        })
    }
}

ResearchAssistantController.$inject = ['$scope', 'researchAssistantService', 'apiService', 'appStateService', 'documentService']

angular.module('summonApp.directives')
    .controller('researchAssistantController', ResearchAssistantController)
    .directive('researchAssistant', ['$rootScope', '$authEvents', 'localizationService', 'configService', 'authenticationService', 'researchAssistantService', ResearchAssistant]);

